import React from "react";

import { ToneSegments } from "../../../../components/FormPanel";
import {
  FormInput,
  FormMoneyInput,
  InputDate,
  SelectForm,
} from "../../../../components/Input";
import {
  Card,
  CardLabel,
  HelperText,
} from "../../../../components/MobileForm/styles";
import { localToday } from "../../../../utils";
import { validateAmount } from "../tradeValidation";
import { DIRECTION_SEGMENTS } from "./constants";
import { MobileBrokerageTransferFormProps } from "./types";
import { TransferSummary } from "./styles";

export const MobileBrokerageTransferForm: React.FC<
  MobileBrokerageTransferFormProps
> = ({
  control,
  direction,
  externalAccountOptions,
  minDate,
  dateRules,
  transferSummary,
  isDisabled,
  onDirectionChange,
}) => (
  <>
    <Card>
      <CardLabel as="span">Direction *</CardLabel>
      <ToneSegments
        groupLabel="Transfer direction"
        options={DIRECTION_SEGMENTS}
        selectedValue={direction}
        disabled={isDisabled}
        onChange={(segment) => onDirectionChange(segment.value)}
      />

      <CardLabel htmlFor="mobile-brokerage-transfer-account">
        External account *
      </CardLabel>
      <SelectForm
        id="mobile-brokerage-transfer-account"
        name="externalAccount"
        control={control}
        rules={{ required: "External account is required!" }}
        defaultValue={null}
        options={externalAccountOptions}
        disabled={isDisabled}
      />
      <HelperText>Choose the bank account at the other end.</HelperText>
    </Card>

    <Card>
      <CardLabel htmlFor="mobile-brokerage-transfer-amount">Amount *</CardLabel>
      <FormMoneyInput
        id="mobile-brokerage-transfer-amount"
        required
        name="amountEur"
        control={control}
        rules={{ validate: validateAmount }}
        disabled={isDisabled}
        placeholder="0.00"
        variant="title"
      />
      {transferSummary && <TransferSummary>{transferSummary}</TransferSummary>}
    </Card>

    <Card>
      <CardLabel htmlFor="mobile-brokerage-transfer-date">Date *</CardLabel>
      <InputDate
        id="mobile-brokerage-transfer-date"
        name="date"
        control={control}
        rules={dateRules}
        disabled={isDisabled}
        minDate={minDate}
        maxDate={localToday()}
        placeholder="YYYY/MM/DD"
      />
      <HelperText>Must be on or after both accounts' start dates.</HelperText>

      <CardLabel htmlFor="mobile-brokerage-transfer-note">Note</CardLabel>
      <FormInput
        id="mobile-brokerage-transfer-note"
        name="note"
        control={control}
        disabled={isDisabled}
        placeholder="Optional"
      />
    </Card>
  </>
);
